import { Flex, Text } from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';

interface CreateOfferReviewStatusProps {
  hasSelection: boolean;
  hasTiers: boolean;
}

export function CreateOfferReviewStatus({
  hasSelection,
  hasTiers,
}: CreateOfferReviewStatusProps) {
  const { t } = useTranslation();
  const text = !hasSelection
    ? t('offer.selectAcceptedInquiry')
    : !hasTiers
    ? t('offer.noOfferTiersAvailable')
    : t('offer.ready');
  const hasWarning = !hasSelection || !hasTiers;

  return (
    <Flex
      align="center"
      color={
        !hasTiers
          ? 'offerDrawer.mutedText'
          : hasWarning
          ? 'offerDrawer.warning'
          : 'offerDrawer.success'
      }
      gap={2}
    >
      {!hasTiers || hasWarning ? (
        <Icons.AlertCircleOutline boxSize={4} />
      ) : (
        <Icons.CheckCircleOutline boxSize={4} />
      )}
      <Text fontSize="11px" fontWeight="semibold">
        {text}
      </Text>
    </Flex>
  );
}
